import React, { useEffect, useState } from 'react';
import { FieldArray } from 'formik';
import { connect } from 'react-redux';
import { Grid, Header, Pagination, Table, Checkbox } from 'semantic-ui-react';
// import { Checkbox } from 'formik-semantic-ui';
import moment from 'moment';
import { getSalesOrder, selectSoData } from '../../redux/actions/salesOrderActions';
import { ERROR_MESSAGES } from '../../config/const';
import { salesOrderConst } from '../../utils/constant';
import { RichSelectRow } from 'ag-grid-enterprise';

const ActivePurchaseOrder = ({ editmode, fromView, ...props }) => {
    const [currentPage, setCurrentPage] = useState(props?.getSalesOrderPagination?.currentPage ? props?.getSalesOrderPagination?.currentPage : 1)
    const [totalPages, setTotalPages] = useState()
    const [searchValue, setSearchValue] = useState('')
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [loadingData, setLoadingData] = useState(false)
    const { getSalesOrder, getSalesOrderPagination, selectSoData, selectedCheck, allSoIds } = props;
    const [searchText, setSearchText] = useState(props.searchTextProps);

    useEffect(() => {
        if (props?.customerCode) {
            setTotalPages(props?.customerSalesOrderPagination?.totalPages)
            setCurrentPage(props?.customerSalesOrderPagination?.currentPage)
        }
    }, [props.customerSalesOrderPagination])

    const searchString = (e) => {
        if (e.keyCode == 13) {
            props.handleSearchStringCall(e.target.value);
            setCurrentPage(1)
            setTotalPages(1)
        }
    };

    const handlePaginationChange = (e, { activePage }) => {
        setCurrentPage(activePage)
        setLoadingData(true)
        props.activeSOData = []
        getSalesOrder(itemsPerPage, searchValue, activePage, props.customerCode, '', '', true)
    }
    return (
        <div className="ui form">
            <FieldArray name="activeSODetails">
                {({ form }) => {
                    const { values } = form
                    const { activeSODetails, manualSoAddedTotal } = values

                    let tempSOAmount = []
                    let selectedSO = []

                    activeSODetails.filter((item) => {
                        if (item.checkbox === true) {
                            tempSOAmount.push(item.soAmount)
                            selectedSO.push(item)
                        }
                    })

                    if (editmode) {
                        values.finalAmount = tempSOAmount.reduce((total, obj) => parseFloat(obj) + parseFloat(total), 0).toFixed(2)
                    } else {
                        values.activeSoAddedTotal = tempSOAmount.reduce((total, obj) => parseFloat(obj) + parseFloat(total), 0).toFixed(2)
                        values.finalAmount = +manualSoAddedTotal + +values.activeSoAddedTotal
                    }

                    values.activeSOSelected = selectedCheck

                    return (
                        <>
                            {/* <label>{salesOrderConst.SALES_ORDER} {" "}</label> */}
                            {
                                selectedCheck && selectedCheck.length > 0 ?
                                    <>
                                        <br />
                                        <br />
                                        <b> Mapped Sales Order</b>
                                        <Table unstackable size="large" compact="very" className="w3-small">
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell className="labelName p-bold-600">SO Number</Table.HeaderCell>
                                                    <Table.HeaderCell className="labelName p-bold-600">LR Number</Table.HeaderCell>
                                                    <Table.HeaderCell className="labelName p-bold-600">LR Date</Table.HeaderCell>
                                                    <Table.HeaderCell className="labelName p-bold-600">Reference Number</Table.HeaderCell>
                                                    <Table.HeaderCell className="labelName p-bold-600">SO Date</Table.HeaderCell>
                                                    {/* <Table.HeaderCell className="labelName p-bold-600">Delivery Date</Table.HeaderCell> */}
                                                    {/* <Table.HeaderCell className="labelName p-bold-600">TDS Amount</Table.HeaderCell> */}
                                                    <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {selectedCheck.map((object, index) => {
                                                    return (
                                                        <Table.Row verticalAlign="middle" key={index}>
                                                            <React.Fragment>
                                                                <Table.Cell>
                                                                    {object?.soNumber ? object?.soNumber : object?.so_number || ''}
                                                                </Table.Cell>
                                                                <Table.Cell>
                                                                    {object?.lr_no ? object?.lr_no : ''}
                                                                </Table.Cell>
                                                                <Table.Cell>
                                                                    {object?.lr_date ? moment(object?.lr_date).format("DD-MM-YYYY") : ''}
                                                                </Table.Cell>
                                                                <Table.Cell>
                                                                    {object?.soReferenceNo ? object?.soReferenceNo : object?.reference_number || ''}
                                                                </Table.Cell>
                                                                <Table.Cell >
                                                                    {object?.soDate ?
                                                                        moment(object.soDate).format("DD-MM-YYYY")
                                                                        : moment(object?.so_date).format("DD-MM-YYYY") || moment(object.soDate).format("DD-MM-YYYY")}
                                                                </Table.Cell>
                                                                <Table.Cell>
                                                                    {object?.soAmount ? object?.soAmount : object?.so_amount || ''}
                                                                </Table.Cell>
                                                            </React.Fragment>
                                                        </Table.Row>
                                                    )
                                                }
                                                )}
                                            </Table.Body>
                                        </Table>
                                    </>
                                    : null

                            }
                            {
                                props.view != true ?
                                    <div class="ui focus input pb-2 mt-4 ml-4" style={{ right: 0, position: 'absolute' }}>
                                        <input
                                            type="text"
                                            defaultValue={searchText}
                                            placeholder={salesOrderConst.SEARCH_SALES_ORDER}
                                            onKeyUp={searchString}
                                        />
                                    </div> : null
                            }

                            <br />
                            <br />
                            <br />
                            {
                                !props?.view &&
                                <>
                                    <b> Unmapped Sales Order</b>
                                    <Table unstackable size="large" compact="very" className="w3-small">
                                        <Table.Header>
                                            <Table.Row>
                                                {!fromView ?
                                                    <Table.HeaderCell className="labelName p-bold-600"></Table.HeaderCell>
                                                    : null
                                                }
                                                <Table.HeaderCell className="labelName p-bold-600">SO Number</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">LR Number</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">LR Date</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Reference Number</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">SO Date</Table.HeaderCell>
                                                {/* <Table.HeaderCell className="labelName p-bold-600">TDS Amount</Table.HeaderCell> */}
                                                <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>

                                        <Table.Body>

                                            {

                                                (props?.activeSOData?.length > 0 || activeSODetails?.length > 0) && props?.customerCode?.length > 0 ? <>
                                                    {(props?.activeSOData ? props?.activeSOData : activeSODetails).map((object, index) => {

                                                        return (
                                                            <Table.Row verticalAlign="middle">

                                                                <React.Fragment>
                                                                    {!fromView ?
                                                                        <Table.Cell>
                                                                            <Checkbox
                                                                                onChange={(e, data) => selectSoData(object)}
                                                                                name={`activeSODetails[${index}].checkbox`}
                                                                                value={object?.checkbox ? props.activeSOData[index].checkbox : activeSODetails?.[index]?.checkbox}
                                                                                checked={allSoIds.includes(object.soId) ? true : false}
                                                                            />
                                                                        </Table.Cell>
                                                                        : null}
                                                                    <Table.Cell>
                                                                        {props?.activeSOData?.[index]?.soNumber ? props?.activeSOData[index].soNumber : activeSODetails[index].soNumber}
                                                                    </Table.Cell>
                                                                    <Table.Cell>
                                                                        {props?.activeSOData?.[index]?.lr_no ? props?.activeSOData[index]?.lr_no : activeSODetails[index]?.lr_no}
                                                                    </Table.Cell>
                                                                    <Table.Cell>
                                                                        {props?.activeSOData?.[index]?.lr_date ? moment(props?.activeSOData[index]?.lr_date).format("DD-MM-YYYY") : activeSODetails[index]?.lr_date}
                                                                    </Table.Cell>
                                                                    <Table.Cell>
                                                                        {props?.activeSOData?.[index]?.soReferenceNo ? props?.activeSOData[index].soReferenceNo : activeSODetails[index].soReferenceNo}
                                                                    </Table.Cell>
                                                                    <Table.Cell>
                                                                        {props?.activeSOData?.[index]?.soDate ? moment(props?.activeSOData[index].soDate).format("DD-MM-YYYY") : "NA" ? activeSODetails[index].soDate : moment(activeSODetails[index].soDate).format("DD-MM-YYYY")}
                                                                    </Table.Cell>
                                                                    {/* <Table.Cell>
                                                            {activeSODetails[index].tdsAmount}
                                                        </Table.Cell> */}
                                                                    <Table.Cell>
                                                                        {props?.activeSOData?.[index]?.soAmount ? props.activeSOData[index].soAmount : activeSODetails[index].soAmount}
                                                                    </Table.Cell>
                                                                </React.Fragment >
                                                            </Table.Row >
                                                        )
                                                    }
                                                    )}</> : <Table.Row verticalAlign="middle">
                                                    <Table.Cell><div></div></Table.Cell>
                                                    <Table.Cell><div></div></Table.Cell>
                                                    <Table.Cell><div className='text-center'>{ERROR_MESSAGES.NO_DATA_FOUND}</div></Table.Cell>
                                                </Table.Row>}
                                        </Table.Body >
                                    </Table >
                                    {(props?.activeSOData?.length > 0 || activeSODetails?.length > 0) && props?.customerCode?.length > 0 && <Pagination
                                        defaultActivePage={currentPage}
                                        firstItem={null}
                                        lastItem={null}
                                        onPageChange={handlePaginationChange}
                                        pointing
                                        secondary
                                        totalPages={totalPages}
                                    />}
                                </>
                            }
                            <Grid columns={3}>
                                <Grid.Row className="p-2">
                                    <Grid.Column width={10} />
                                    <Grid.Column>
                                        {editmode ?
                                            ""
                                            :
                                            <>
                                                <Grid.Row>
                                                    <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Active SO Total</Header>
                                                    <Header floated="right" as="label" className="labelName" size="tiny">₹ {selectedCheck?.length > 0 && Number(selectedCheck.map(item => item.soAmount || item.so_amount).reduce((prev, next) => parseInt(prev) + parseInt(next))).toFixed(2)}</Header>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">New SO Total</Header>
                                                    <Header floated="right" as="label" className="labelName" size="tiny">₹ {Number(manualSoAddedTotal).toFixed(2)}</Header>
                                                </Grid.Row>
                                            </>
                                        }
                                        <Grid.Row>
                                            <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Total</Header>
                                            <Header floated="right" as="label" className="labelName" size="tiny">₹ {selectedCheck?.length > 0 && Number(selectedCheck.map(item => item.soAmount || item.so_amount).reduce((prev, next) => parseInt(prev) + parseInt(next))).toFixed(2)}</Header>
                                        </Grid.Row>

                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </>
                    )
                }
                }
            </FieldArray >
        </div >
    )
}

const mapStatetoProps = (state) => ({
    selectedCheck: state.generatePdfData.allCheckData,
    allSoIds: state.generatePdfData.allSoIds
})

export default connect(mapStatetoProps, { selectSoData, getSalesOrder })(ActivePurchaseOrder)